import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useDictionary } from "hooks";
import Helper from "./helpers";

import { HAPLO_ETHICS_API } from "globals/constants";

import IntegrationComponent from "components/flowable/Integration/IntegrationComponent";

const HaploEthicsMonitor = props => {
	const { onChange, onEvent, config } = props;
	const params = useParams();
	const dictionary = useDictionary("haploEthicsIntegration");

	config.value = params.proposalId ?? params.awardId;

	const haploEthicsDictionary = useMemo(() => {
		return {
			headline: dictionary?.headline || "Link to Ethics Monitor Studies",
			description: dictionary?.description,
			noData: dictionary?.noData ?? "No  Ethics Monitor records are linked to this SP record. Links can be created from the desired Ethics Monitor record as applicable.",
			errorMessage: dictionary?.errorMessage,
			infoText: dictionary?.infoText
		}
	}, [ dictionary ]);

	const cardKeys = useMemo(() => {
		return {
			applicationID: dictionary?.protocolNumber ?? "Study ID",
			title:  dictionary?.title ?? "Title",
			approvalDate:  dictionary?.approvalDate ?? "Approval Date",
			expiryDate:  dictionary?.expirationDate ?? "Expiration Date",
			applicationLead:  dictionary?.principleInvestigator ?? "Lead PI",
			statusDisplay:  dictionary?.status ?? "Status"
		}
	}, [ dictionary ]);

	return (
		<IntegrationComponent
			helper={Helper}
			url={HAPLO_ETHICS_API}
			cardKeys={cardKeys}
			dictionary={haploEthicsDictionary}
			config={config}
			onChange={onChange}
			onEvent={onEvent}
		/>
	);
};

export default HaploEthicsMonitor;
